import React from "react";

import AppAllLeave from "components/pages/leave-management/app-leave-all-history";

const PageAllLeave = () => {

    return (
        <div className="page-leave">
            <div className="leave">
                <AppAllLeave />
            </div>
        </div>
    );
};

export default PageAllLeave;
